import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { Container } from "@mui/system";

import { green } from "@mui/material/colors";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useConfirmPasswordRequestMutation } from "../../../services/apiSlice";

const defaultValues = {
  password: "",
  confirm_password: "",
};
//
const ChangePassword = () => {
  const navigate = useNavigate();
  const [confirmPasswordRequest, { data, error, isError, isSuccess }] =
    useConfirmPasswordRequestMutation();

  const [searchParams, setSearchParams] = useSearchParams();
  let dataOne = searchParams.get("dataOne");
  let dataTwo = searchParams.get("dataTwo");
  let UserId = searchParams.get("userId");
  console.log({ searchParams });
  const methods = useForm({ defaultValues: defaultValues });
  const {
    handleSubmit,

    register,
    getValues,
    formState: { errors },
  } = methods;
  useEffect(() => {
    console.log({ data });
    if (isSuccess && data && data?.success === true) {
      Swal.fire("Awesome!", ` ${data.message}`, "success").then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          navigate("/login");
        }
      });
    } else if (isError) {
      //error
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
    } else if (data?.success === false) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data?.message,
      });
    }
  }, [data, isError]);

  const onSubmit = async (data) => {
    console.log("pass req", data);
    const changePasswordData = {
      dataOne,
      dataTwo,
      userId: UserId,
      password: data.password,
      confirm_password: data.confirm_password,
    };
    await confirmPasswordRequest(changePasswordData).unwrap();
  };
  return (
    <>
      <Container>
        <Box maxWidth={"md"} className="min-h-screen" sx={{ mt: 10 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Paper
              style={{
                display: "flex",
                flexDirection: "column",
                gridRowGap: "20px",
                padding: "20px",
                // margin: "30px 300px",
              }}
              sx={{
                width: "md",
              }}
            >
              <Typography
                variant="h1"
                component="h2"
                className="md:text-3xl text-base uppercase font-extrabold text-center py-2 md:py-4 "
                sx={{ textAlign: "center" }}
              >
                Change password
              </Typography>

              <TextField
                id="outlined-basic"
                name="password"
                label="New Password"
                variant="outlined"
                fullWidth
                size={"small"}
                type={"password"}
                {...register("password", {
                  required: "password  is Required",
                  minLength: {
                    value: 8,
                    message: "Password should have at-least 8 characters.",
                  },
                  pattern: {
                    value:
                      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                    message:
                      "The password must contain atleast one uppercase, one lowercase and one special characters",
                  },
                })}
                error={Boolean(errors.password)}
                helperText={
                  errors.password && errors.password.type === "required"
                    ? errors.password.message
                    : errors.password && errors.password.type === "minLength"
                    ? errors.password.message
                    : errors.password &&
                      errors.password.type === "pattern" &&
                      errors.password.message
                }
              />
              <TextField
                id="outlined-basic"
                name="confirm_password"
                label="Confirm New Password"
                variant="outlined"
                fullWidth
                size={"small"}
                type={"password"}
                {...register("confirm_password", {
                  required: "confirm password  is Required",
                  minLength: {
                    value: 8,
                    message:
                      "confirm password should have at-least 8 characters.",
                  },
                  pattern: {
                    value:
                      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                    message:
                      "The confirm password must contain atleast one uppercase, one lowercase and one special characters",
                  },
                  validate: (value) => {
                    // const { password } = getValue()
                    return (
                      value === getValues("password") ||
                      "Comfirm password does not match with password!"
                    );
                  },
                })}
                error={Boolean(errors.confirm_password)}
                helperText={
                  errors.confirm_password &&
                  errors.confirm_password.type === "required"
                    ? errors.confirm_password.message
                    : errors.confirm_password &&
                      errors.confirm_password.type === "minLength"
                    ? errors.confirm_password.message
                    : errors.confirm_password &&
                      errors.confirm_password.type === "pattern"
                    ? errors.confirm_password.message
                    : errors.confirm_password &&
                      errors.confirm_password.type === "validate" &&
                      errors.confirm_password.message
                }
              />

              <div className="clearfix"></div>
              <Button
                variant="contained"
                type="submit"
                className="hover:bg-green-300"
                sx={{
                  color: "white",
                  background: green[600],
                  // width: "40%",
                  // mx: 30,
                  textAlign: "center",
                  placeItems: "center",
                }}
              >
                Change Password
              </Button>

              <Typography
                variant="p"
                component="p"
                className="text-base  font-normal text-center py-2 md:py-4 "
                sx={{ textAlign: "center" }}
              >
                Remebered your password? cancel and{" "}
                <Link to={"/login"}>
                  {" "}
                  <Typography
                    variant="span"
                    component="span"
                    className="text-blue-500 text-lg  mx-2 font-normal text-center py-2 md:py-4 "
                    sx={{ textAlign: "center" }}
                  >
                    Login
                  </Typography>{" "}
                </Link>
              </Typography>
            </Paper>
          </form>
        </Box>
      </Container>
    </>
  );
};

export default ChangePassword;
